import {Icon, Stack, Typography} from '@voltmoney/component';
import {
  ColorTokens,
  FontFamilyTokens,
  FontSizeTokens,
  IconSizeTokens,
  IconTokens,
  StackType,
  StackWidth,
} from '@voltmoney/schema';
import React from 'react';
import {
  Pressable,
  StyleSheet,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from 'react-native';
import {BreakPoints, redirectToFaq} from './configs/util';
import ThemeProvider from '@voltmoney/theme';
import {partnerHelplineNumber, WhatsAppLink} from './configs/constants';

let theme = ThemeProvider.getTheme();
let colorMapping = theme.colors;

const styles = StyleSheet.create({
  headerContainer: {
    width: '100%',
    height: 44,
    flexDirection: 'row',
    paddingLeft: 16,
    paddingRight: 16,
    top: 0,
  },
  headerContainerWeb: {
    width: '100%',
    height: 64,
    flexDirection: 'row',
    justifyContent: 'center',
    paddingLeft: 32,
    paddingRight: 32,
    borderBottomColor: colorMapping[ColorTokens.Grey_Chalk],
    borderBottomWidth: 1,
  },
  headerLeftContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerLeftContainerWeb: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    minWidth: 500,
    maxWidth: 660,
    width: '50%',
  },
  headerRightContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  headerRightContainerWeb: {
    width: '50%',
    minWidth: 500,
    maxWidth: 640,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  headerPartnerContainerWeb: {
    position: 'relative',
    bottom: 15,
  },
  headerPartnerContainer: {
    position: 'relative',
    top: 8,
  },
});

const PartnerHeader: React.FunctionComponent = () => {
  const {width} = useWindowDimensions();

  const redirectToPartnerWeb = () => {
    window.open('/partner/', '_self');
  };

  return (
    <View
      style={
        width < BreakPoints.WEB
          ? styles.headerContainer
          : styles.headerContainerWeb
      }>
      {
        //mobile
        width < BreakPoints.WEB ? (
          <>
            <Pressable
              style={styles.headerLeftContainer}
              onPress={redirectToPartnerWeb}>
              <Icon.Component
                name={IconTokens.VoltFull}
                size={IconSizeTokens.XXXXXXXL}
              />
              <View style={{width: 5}} />
              <View style={styles.headerPartnerContainer}>
                <Typography.Component
                  label="Partners"
                  color={ColorTokens.Primary_100}
                  fontSize={FontSizeTokens.XXS}
                  fontWeight="600"
                  lineHeight={16}
                />
              </View>
            </Pressable>
          </>
        ) : (
          <></>
        )
      }
      {
        //web
        width > BreakPoints.WEB ? (
          <Pressable
            style={styles.headerLeftContainerWeb}
            onPress={redirectToPartnerWeb}>
            <Icon.Component
              name={IconTokens.VoltFull}
              size={IconSizeTokens.XXXXXXXL}
            />
            <View style={{width: 5}} />
            <View style={styles.headerPartnerContainerWeb}>
              <Typography.Component
                label="Partners"
                color={ColorTokens.Primary_100}
                fontSize={FontSizeTokens.XS}
                fontWeight="600"
                lineHeight={18}
              />
            </View>
          </Pressable>
        ) : (
          <></>
        )
      }
      <View
        style={
          width < BreakPoints.WEB
            ? styles.headerRightContainer
            : styles.headerRightContainerWeb
        }>
        {
          //mobile
          width < BreakPoints.WEB ? (
            <>
              <Pressable onPress={redirectToFaq}>
                <Typography.Component
                  label="FAQs"
                  color={ColorTokens.Grey_Night}
                  fontSize={FontSizeTokens.SM}
                  fontFamily={FontFamilyTokens.Inter}
                  fontWeight="600"
                  lineHeight={20}
                />
              </Pressable>
              <View style={{width: 15}} />
              <View>
                <Typography.Component
                  label="Need help? "
                  color={ColorTokens.Grey_Night}
                  fontSize={FontSizeTokens.XS}
                  fontFamily={FontFamilyTokens.Inter}
                  fontWeight="400"
                  lineHeight={18}
                />
              </View>
              <View style={{width: 15}} />
              <TouchableOpacity
                onPress={() =>
                  window.open(`tel:+91${partnerHelplineNumber}`, '_parent')
                }>
                <View>
                  <Icon.Component
                    name={IconTokens.Phone}
                    color={ColorTokens.Primary_100}
                    size={IconSizeTokens.XXL}
                  />
                </View>
              </TouchableOpacity>
              <View style={{width: 15}} />
              <TouchableOpacity
                onPress={() =>
                  window.open(`${WhatsAppLink.helpPartner}`, '_parent')
                }>
                <View>
                  <Icon.Component
                    name={IconTokens.Whatsapp}
                    size={IconSizeTokens.XXL}
                  />
                </View>
              </TouchableOpacity>
            </>
          ) : (
            <></>
          )
        }
        {
          //web
          width > BreakPoints.WEB ? (
            <>
              <Pressable onPress={redirectToFaq}>
                <Typography.Component
                  label="FAQs"
                  color={ColorTokens.Grey_Night}
                  fontSize={FontSizeTokens.SM}
                  fontFamily={FontFamilyTokens.Inter}
                  fontWeight="600"
                  lineHeight={20}
                />
              </Pressable>
              <View style={{width: 24}} />
              <View>
                <Stack.Component
                  type={StackType.row}
                  width={StackWidth.CONTENT}>
                  <Typography.Component
                    label="Need help?"
                    fontSize={FontSizeTokens.SM}
                    fontFamily={FontFamilyTokens.Inter}
                    fontWeight={'500'}
                    lineHeight={20}
                    color={ColorTokens.Grey_Night}
                  />
                </Stack.Component>
              </View>
              <View style={{width: 24}} />
              <TouchableOpacity
                onPress={() =>
                  window.open(`tel:+91${partnerHelplineNumber}`, '_parent')
                }>
                <View>
                  <Stack.Component
                    type={StackType.row}
                    width={StackWidth.CONTENT}>
                    <Icon.Component name={IconTokens.Phone} />
                    <View style={{width: 6}} />
                    <Typography.Component
                      label="96117 49295"
                      fontSize={FontSizeTokens.SM}
                      fontWeight={'500'}
                      lineHeight={20}
                      color={ColorTokens.Primary_100}
                    />
                  </Stack.Component>
                </View>
              </TouchableOpacity>
              <View style={{width: 24}} />
              <TouchableOpacity
                onPress={() =>
                  window.open(
                    `https://api.whatsapp.com/send?phone=91${partnerHelplineNumber}`,
                  )
                }>
                <View>
                  <Stack.Component
                    type={StackType.row}
                    width={StackWidth.CONTENT}>
                    <Icon.Component name={IconTokens.Whatsapp} />
                    <View style={{width: 6}} />
                    <Typography.Component
                      label="Chat with us"
                      fontSize={FontSizeTokens.SM}
                      fontWeight={'500'}
                      lineHeight={20}
                      color={ColorTokens.Primary_100}
                    />
                  </Stack.Component>
                </View>
              </TouchableOpacity>
            </>
          ) : (
            <></>
          )
        }
      </View>
    </View>
  );
};

export default PartnerHeader;
